function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import isPropValid from "@emotion/is-prop-valid";
import { Skeleton, styled } from "@mui/material";
import { useId } from "react";
import { useIsAnimationActive } from "../helpers";
var LoadingStyled = styled(Skeleton, {
    shouldForwardProp: isPropValid
})(function(_param) {
    var height = _param.height, theme = _param.theme, width = _param.width, props = _object_without_properties(_param, [
        "height",
        "theme",
        "width"
    ]);
    var variantStyles = {
        a1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        a2: {
            borderRadius: '0.625rem',
            width: '7rem'
        },
        b1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        b2: {
            borderRadius: '0.625rem',
            width: '7rem'
        },
        c1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        c2: {
            borderRadius: '0.625rem',
            width: '12rem'
        },
        d1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        d2: {
            borderRadius: '0.437rem',
            width: '12rem'
        },
        e1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        e2: {
            borderRadius: '0.437rem',
            width: '12rem'
        },
        f1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        f2: {
            borderRadius: '0.3125rem',
            width: '7rem'
        },
        g1: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        g2: {
            borderRadius: '0.437rem',
            width: '6rem'
        },
        i1: {
            borderRadius: '0.3125rem',
            width: '6rem'
        },
        i2: {
            borderRadius: '0.3125rem',
            width: '6rem'
        },
        j1: {
            borderRadius: '0.3125rem',
            width: '6rem'
        },
        j2: {
            borderRadius: '0.3125rem',
            width: '6rem'
        },
        k3: {
            borderRadius: '0.437rem',
            width: '7rem'
        }
    }[props['data-variant']] || {
        borderRadius: '0.3125rem',
        width: '100%'
    };
    return {
        borderRadius: variantStyles.borderRadius,
        display: 'inline-block',
        maxWidth: '100%',
        width: variantStyles.width
    };
});
export var Loading = function(_param) {
    var variant = _param.variant, props = _object_without_properties(_param, [
        "variant"
    ]);
    var isAnimationActive = useIsAnimationActive();
    var labelId = useId();
    return /*#__PURE__*/ _jsxs(LoadingStyled, _object_spread_props(_object_spread({}, props), {
        animation: isAnimationActive ? undefined : false,
        "aria-busy": true,
        "aria-labelledby": props['aria-labelledby'] || labelId,
        "aria-valuetext": "Loading",
        "data-variant": variant,
        role: "progressbar",
        children: [
            /*#__PURE__*/ _jsx(_Fragment, {
                children: "\xa0"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                id: labelId,
                role: "presentation",
                children: "Loading"
            })
        ]
    }));
};
Loading.displayName = 'Loading';

//# sourceMappingURL=Loading.js.map